/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:7dfb94ce-ee92-42c2-9c75-6b87b9c94f22",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_JuetibjQP",
    "aws_user_pools_web_client_id": "5sq90d97rocnrrhjska059nhe3",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
